export default "__VITE_ASSET__D5zYGDQZ__"